export const countries = [
    {label: "Alemania", value: "Alemania"},
    {label: "Andorra", value: "Andorra"},
    {label: "Argentina", value: "Argentina"},
    {label: "Austria", value: "Austria"},
    {label: "Belice", value: "Belice"},
    {label: "Bolivia", value: "Bolivia"},
    {label: "Brasil", value: "Brasil"},
    {label: "Canadá", value: "Canadá"},
    {label: "Chile", value: "Chile"},
    {label: "Colombia", value: "Colombia"},
    {label: "Costa Rica", value: "Costa Rica"},
    {label: "Croacia", value: "Croacia"},
    {label: "Cuba", value: "Cuba"},
    {label: "Dinamarca", value: "Dinamarca"},
    {label: "Ecuador", value: "Ecuador"},
    {label: "El Salvador", value: "El Salvador"},
    {label: "España", value: "España"},
    {label: "Estados Unidos", value: "Estados Unidos"},
    {label: "Finlandia", value: "Finlandia"},
    {label: "Francia", value: "Francia"},
    {label: "Grecia", value: "Grecia"},
    {label: "Guatemala", value: "Guatemala"},
    {label: "Honduras", value: "Honduras"},
    {label: "Italia", value: "Italia"},
    {label: "México", value: "México"},
    {label: "Nicaragua", value: "Nicaragua"},
    {label: "Noruega", value: "Noruega"},
    {label: "Panamá", value: "Panamá"},
    {label: "Paraguay", value: "Paraguay"},
    {label: "Perú", value: "Perú"},
    {label: "Polonia", value: "Polonia"},
    {label: "Portugal", value: "Portugal"},
    {label: "Reino Unido", value: "Reino Unido"},
    {label: "Rusia", value: "Rusia"},
    {label: "Suecia", value: "Suecia"},
    {label: "Suiza", value: "Suiza"},
    {label: "Uruguay", value: "Uruguay"},
    {label: "Venezuela", value: "Venezuela"}
]
